import React, { useContext } from 'react';
const DEFAULT_TWO_STEP_AUTH_TIMED_OUT = false;
const TwoStepAuthTimedOut = /*#__PURE__*/React.createContext({
  isTwoStepAuthTimedOut: DEFAULT_TWO_STEP_AUTH_TIMED_OUT,
  setTwoStepAuthTimedOut: isVerified => isVerified
});
export function useTwoStepAuthTimedOut() {
  return useContext(TwoStepAuthTimedOut);
}
export default TwoStepAuthTimedOut;